// extracted by mini-css-extract-plugin
export default {"BigToutButton":"styles_BigToutButton__TTvOG","shadowMotion1":"styles_shadowMotion1__Ek2dt"};